import { render } from "./HomeSpeakersList.vue?vue&type=template&id=126c2610"
import script from "./HomeSpeakersList.vue?vue&type=script&lang=ts"
export * from "./HomeSpeakersList.vue?vue&type=script&lang=ts"
script.render = render

export default script